import { AuthClient, type GoTrueClient } from '@supabase/auth-js';

import { supabaseConfig, type SupabaseConfig } from './supabase-config';

/**
 * Browser Supabase Auth client (ADR 0004): PKCE flow, persisted session with
 * automatic refresh, and code exchange on redirect landings. Product data
 * always goes through the FastAPI boundary, so the app needs only Auth.
 *
 * Built on @supabase/auth-js directly rather than supabase-js `createClient`,
 * which would also bundle the unused storage, database, realtime, and
 * functions clients (~20% of the bundle). The options mirror what
 * `createClient` passes, including the `sb-<ref>-auth-token` storage key, so
 * persisted sessions carry over unchanged.
 */
export function createSupabaseClient(config: SupabaseConfig = supabaseConfig): GoTrueClient {
  const base = new URL(config.url.endsWith('/') ? config.url : `${config.url}/`);
  return new AuthClient({
    url: new URL('auth/v1', base).href,
    headers: {
      Authorization: `Bearer ${config.publishableKey}`,
      apikey: config.publishableKey,
    },
    storageKey: `sb-${base.hostname.split('.')[0]}-auth-token`,
    flowType: 'pkce',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  });
}
